import {
  materialHorizontalLayoutTester,
  MaterialVerticalLayout,
  materialVerticalLayoutTester,
} from "@jsonforms/material-renderers";
import ArrayRenderer from "../renderers/ArrayRenderer";
import { appointmentPickerTester, arrayLayoutTester } from "../testers";
import AppointmentPickerViewRenderer from "./AppointmentPickerViewRenderer";
import NotesViewRenderer, {
  isOverrideViewTester,
  notesViewTester,
} from "./NotesViewRenderer";
import OneOfRadioGroupControl, {
  oneOfRadioGroupControlTester,
} from "./OneOfRadioGroupControl";
import StringViewRenderer, { stringViewTester } from "./StringViewRenderer";
import DateViewRenderer, { dateViewTester } from "./DateViewRenderer";
import PhoneNumberWithCountryCodeViewRenderer, {
  phoneNumberWithCountryCodeViewTester,
} from "./PhoneNumberWithCountryCodeViewRenderer";
import GroupViewRenderer, { groupViewTester } from "./GroupViewRenderer";
import { UnknownRenderer, unknownRendererTester } from "./UnknownRenderer";
import {
  HiddenFieldViewRenderer,
  hiddenFieldViewTester,
} from "./HiddenFieldViewRenderer";
import InputWithAdornmentViewRenderer, {
  inputWithAdornmentViewTester,
} from "./InputWithAdornmentViewRenderer";
import DataWithDynamicUnitViewRenderer, {
  dataWithDynamicUnitViewTester,
} from "./DataWithDynamicUnitViewRenderer";
import DataLabelRenderer, { dataLabelTester } from "./LabelRenderer";
import VisitPickerViewRenderer, {
  visitPickerTester,
} from "./VisitPickerViewRenderer";
import OneOfDropdownControl, {
  oneOfDropdownControlTester,
} from "./OneOfDropdownControl";
import PhoneNumberViewRenderer, {
  phoneNumberViewTester,
} from "./PhoneNumberViewRenderer";

const customRenderers = [
  { tester: materialVerticalLayoutTester, renderer: MaterialVerticalLayout },
  {
    tester: materialHorizontalLayoutTester,
    renderer: MaterialVerticalLayout,
  },
  {
    tester: appointmentPickerTester,
    renderer: AppointmentPickerViewRenderer,
  },
  {
    tester: notesViewTester,
    renderer: NotesViewRenderer,
  },
  {
    tester: dataLabelTester,
    renderer: DataLabelRenderer,
  },
  {
    tester: arrayLayoutTester,
    renderer: ArrayRenderer,
  },
  {
    tester: oneOfRadioGroupControlTester,
    renderer: OneOfRadioGroupControl,
  },
  {
    tester: oneOfDropdownControlTester,
    renderer: OneOfDropdownControl,
  },
  {
    tester: isOverrideViewTester,
    renderer: () => null,
  },
  {
    tester: stringViewTester,
    renderer: StringViewRenderer,
  },
  {
    tester: dateViewTester,
    renderer: DateViewRenderer,
  },
  {
    tester: phoneNumberWithCountryCodeViewTester,
    renderer: PhoneNumberWithCountryCodeViewRenderer,
  },
  {
    tester: phoneNumberViewTester,
    renderer: PhoneNumberViewRenderer,
  },
  {
    tester: groupViewTester,
    renderer: GroupViewRenderer,
  },
  {
    tester: hiddenFieldViewTester,
    renderer: HiddenFieldViewRenderer,
  },
  {
    tester: dataWithDynamicUnitViewTester,
    renderer: DataWithDynamicUnitViewRenderer,
  },
  {
    tester: inputWithAdornmentViewTester,
    renderer: InputWithAdornmentViewRenderer,
  },
  {
    tester: visitPickerTester,
    renderer: VisitPickerViewRenderer,
  },
  {
    tester: unknownRendererTester,
    renderer: UnknownRenderer,
  },
];

export default customRenderers;
